import * as m from "@/libs/i18n/messages";
import { Outlet, createFileRoute, redirect } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import toast from "react-hot-toast";
import { z } from "zod";

export const Route = createFileRoute("/auth")({
  validateSearch: zodValidator(
    z.object({
      callbackURL: z.string().default("/"),
    }),
  ),
  beforeLoad: ({ context, search, location, preload }) => {
    if (context.auth.session) {
      if (!preload) {
        toast.error(m.misty_weak_herring_sew());
      }

      throw redirect({
        to: search.callbackURL,
      });
    }

    if (["/auth", "/auth/"].includes(location.pathname)) {
      throw redirect({
        to: "/auth/login",
        search,
      });
    }

    return {
      features: ["no-layout"],
    };
  },
  component: AuthLayout,
});

function AuthLayout() {
  return <Outlet />;
}
